<template>
  <div>
    <el-table
      :data="tableData"
      style="width: 100%;margin-bottom: 20px;"
      row-key="id"
      border
      default-expand-all>
      <el-table-column
        prop="fileType"
        label="Excel & DAT Files"
        width="280"
        align="center">
      </el-table-column>
      <el-table-column
        prop="forDate"
        label="Taxable Month & Year"
        align="center">
      </el-table-column>
      <el-table-column
        prop="fileName"
        label="File Name"
        align="center">
      </el-table-column>
      <el-table-column
        prop="createdDate"
        label="Created Date & Time"
        align="center">
      </el-table-column>
      <el-table-column
        prop="createdBy"
        label="Created By"
        align="center">
      </el-table-column>
      <el-table-column
        prop="status"
        label="Status"
        align="center">
        <template slot-scope="scope">
          <div
            v-if="scope.row.status === 'Confirmed'"
            @click="openInfoModal(scope.row)"
            style="color: #67C23A; cursor: pointer;"
            v-html="scope.row.status"></div>
          <div
            v-if="scope.row.status === 'Rejected'"
            @click="openInfoModal(scope.row)"
            style="color: #F56C6C; cursor: pointer;"
            v-html="scope.row.status"></div>
          <div v-if="scope.row.status !== 'Confirmed' && scope.row.status !== 'Rejected'">{{ scope.row.status }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="Action"
        width="150"
        align="center">
        <template slot-scope="scope">
          <el-dropdown v-if="!scope.row.hasOwnProperty('children')">
            <el-button size="small" type="primary">
              Action <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item disabled @click.native="test(scope.row.id)">View</el-dropdown-item>
              <el-dropdown-item @click.native="download(scope.row.urlDownload)">Download</el-dropdown-item>
              <el-dropdown-item v-if="scope.row.fileType === 'DAT'" @click.native="emailToBIR(scope.row)">Email to BIR</el-dropdown-item>
              <el-dropdown-item @click.native="deleteColumn(scope.row.paymentId)">Delete</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <info-modal ref="infoModal" :title="info.title">
      <div v-html="info.text"></div>
    </info-modal>

  </div>
</template>

<script>
  import axios from 'axios'
  let moment = require('moment');
  import InfoModal from '@/components/InfoModal.vue'

  export default {
    components: {
      InfoModal,
    },
    data() {
      return {
        moment: moment,

        info: {
          title: '',
          text: ''
        },

        tableData: [{
          id: 1.1,
          fileType: 'Clients VAT Summary (Output)',
          children: []
        }, {
          id: 2,
          fileType: 'Creditable VAT Summary',
          children: []
        }, {
          id: 3,
          fileType: 'Vendors VAT Summary (Input)',
          children: []
        }, {
          id: 4,
          fileType: 'Importations VAT Summary (Input)',
          children: []
        }]
      }
    },
    methods: {
      openInfoModal(row) {
        this.info.title = row.status
        this.info.text = '<p>' + row.emailReply.replace(/\n{2,}/g, '</p><p>').replace(/\n/g, '<br>') + '</p>'
        this.$refs['infoModal'].openModal()
      },
      loadList() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/taxation-export/payment?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.tableData[0].children = response.data.data.clientOutput
            this.tableData[1].children = response.data.data.creditable
            this.tableData[2].children = response.data.data.vendorInput
            this.tableData[3].children = response.data.data.importationsInput
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      test(id) {

      },
      download(url) {
        document.location.href = url
      },
      async emailToBIR(row) {
        this.$confirm("You are about to email the selected DAT file to the BIR for validation. Please confirm by clicking 'Send.'", this.$t('notification_title_warning'), {
          confirmButtonText: 'Send',
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(async () => {
          let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          await axios.post(`/api/v1/email-bir/create`, {
            companyId: +this.$route.query.companyId,
            paymentId: row.paymentId,
            text: 'testtest',
            subject: 'testtest',
            filename: row.fileName,
            path: row.urlDownload,
          })
          this.loadList()
        } catch (error) {
          console.log(error)
        } finally {
          loader.hide()
        }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Send Email'
          });
        });
      },
      async deleteColumn(id) {
        this.$confirm('This will permanently delete the file. Continue?', this.$t('notification_title_warning'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(async () => {
          let loader = this.$loading.show();
          try {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            await axios.delete(`/api/v1/taxation-export/payment?id=${id}`)
            this.loadList()
          } catch (error) {
            console.log(error)
          } finally {
            loader.hide()
          }

        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general_deleteCanceled')
          });
        });
      },
      tableRowClassName({row, rowIndex}) {
        return 'bg-row';
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
    },
  }
</script>

<style lang="scss" scoped>
.data-hide {
  /deep/.el-table__body-wrapper {
    display: none;
  }
}
/deep/.el-table .bg-row {
  background: #f2f4f7;
}
</style>